import { render, staticRenderFns } from "./PlayerSeasonDetail.vue?vue&type=template&id=bfe4abc8&scoped=true&"
import script from "./PlayerSeasonDetail.vue?vue&type=script&lang=js&"
export * from "./PlayerSeasonDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe4abc8",
  null
  
)

export default component.exports